import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';        
import VehicleAssignment from './components/VehicleAssignment';    
import { useSimaTechContext } from './components/Context';
import './App.css';                                                                    
import VehicleDialog from './components/VehicleDialog';

function App() {
  let navigate = useNavigate();                       
  const { state } = useSimaTechContext();

  useEffect(() => {  
    if (state.vehicleId) {
      navigate('/manager')
    } else {
      navigate('/')
    }
  }, [state.vehicleId]);
                
  return (
    <Routes>
      <Route exact path='/' element={<VehicleDialog />} />
      <Route path='/manager' element={<VehicleAssignment />} />
    </Routes>
  );
}

export default App;